import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { isWebSmDevice } from '../utilities/device_util';

const LightBoxContainer = props => {
  const [transition, setTransition] = useState('');
  const { isPlannerTool } = useSelector(state => state.init);

  const transitionEnd = e => {
    if (e.propertyName !== 'opacity' || transition === 'transition-in') return;

    if (transition === 'transition-out') {
      props.onClick();
    }
  };

  const handleClick = e => {
    // e.preventDefault();
    if (
      typeof e.target.className === 'string' && // if element is svg, className is a object
      e.target.className.indexOf('lightBoxContainer') > -1 &&
      props.onClick
    ) {
      setTransition('transition-out');
    }
  };

  useEffect(() => {
    if (!isPlannerTool) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      if (!isPlannerTool) {
        document.body.style.overflow = 'auto';
      }
    };
  });
  // window.addEventListener
  useEffect(() => {
    const onEscKeyDown = e => {
      if (e.key !== 'Escape') return;
      setTransition('transition-out');
    };
    window.addEventListener('keydown', onEscKeyDown, false);
    setTimeout(() => setTransition('transition-in'), 0);
    return () => {
      window.removeEventListener('keydown', onEscKeyDown, false);
    };
  }, []);

  useEffect(() => {
    if (props.isOpen === false) {
      setTransition('transition-out');
    }
  }, [props.isOpen]);

  // width < 980px buttons bar will show on the top
  const deviceSize =
    isPlannerTool || isWebSmDevice() ? 'sm-device' : 'lg-device';

  return (
    <div
      className={`lightBoxContainer ${deviceSize} ${transition} ${props.className}`}
      role="dialog"
      onTransitionEnd={transitionEnd}
      onMouseDown={handleClick}
      style={{
        position: props.position ? props.position : 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        zIndex: '1000',
        background: props.background ? props.background : 'rgba(0,0,0,0.75)',
      }}
    >
      {Array.isArray(props.children)
        ? React.Children.map(props.children, element => {
            if (!element) return null;
            return <div>{element}</div>;
          })
        : props.children}
    </div>
  );
};

LightBoxContainer.defaultProps = {
  className: '',
  children: null,
  onClick: null,
  background: null,
  position: null,
  isOpen: false,
};

LightBoxContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  onClick: PropTypes.func,
  background: PropTypes.string,
  position: PropTypes.string,
  isOpen: PropTypes.bool,
};

export default LightBoxContainer;
